import React from "react";
var __jsx = React.createElement;
import stl from "./ProgressBar.module.css";
var ProgressBar = function ProgressBar(_ref) {
  var questions = _ref.questions,
    questionsCount = _ref.questionsCount,
    activeQuestionsIndex = _ref.activeQuestionsIndex,
    activeQIndex = _ref.activeQIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.dotsWrapper
  }, Array.from({
    length: questionsCount
  }, function (item, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      className: "\n      ".concat(stl.dot, " \n      ").concat(activeQIndex >= i ? stl.active : "", "\n    ")
    });
  })));
};
export default ProgressBar;